<template>
  <v-date-picker
    :active-picker="setActivePicker"
    :allowed-dates="setAllowedDates"
    :color="setColor"
    :dark="setDark"
    :day-format="setDayFormat"
    :disabled="setDisable"
    :elevation="setElevation"
    :event-color="setEventColor"
    :events="setEvents"
    :first-day-of-week="setFirstDay"
    :flat="setFlat"
    :full-width="setFullWidth"
    :width="setWidth"
    v-model="data"
    @change="handleInput"
  >
  </v-date-picker>
</template>
<script setup>
  import check from "@/../../library/helper/propertyCheck.js";
  import { computed, ref, onMounted } from "vue";

  // Define the properties
  const props = defineProps({ config: { type: Object, required: false } });

  // Property check method
  const propCheck = (key, value) =>
    check.checkSetting(props.config, key, value);

  // Define emits
  const emit = defineEmits(["input"]);

  // Define the data field for the picker
  let data = ref("");

  // Handle the picker input
  const handleInput = () => {
    emit("input", data.value)
  }

  // Visual Settings
  const setActivePicker = computed(() => propCheck("picker", undefined));
  const setAllowedDates = computed(() => propCheck("allowed_dates", null));
  const setColor = computed(() => propCheck("color", undefined));
  const setDark = computed(() => propCheck("dark", false));
  const setDayFormat = computed(() => propCheck("day_format", null));
  const setDisable = computed(() => propCheck("disabled", false));
  const setElevation = computed(() => propCheck("elevation", undefined));
  const setEventColor = computed(() => propCheck("event_color", "warning"));
  const setEvents = computed(() => propCheck("events", null));
  const setFirstDay = computed(() => propCheck("first_day", 0));
  const setFlat = computed(() => propCheck("flat", false));
  const setFullWidth = computed(() => propCheck("full_width", false));
  const setWidth = computed(() => propCheck("width", 290));
</script>
